var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadingMedium = function SvgHeadingMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5 17.75V6.25H4v5h6.5v-5H12v11.5h-1.5v-5H4v5zm11.5 0v-4.692q0-.746.531-1.277a1.74 1.74 0 0 1 1.277-.531h3.884a.3.3 0 0 0 .221-.086.3.3 0 0 0 .087-.222V8.058a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087H14v-1.5h5.692q.746 0 1.277.531t.531 1.277v2.884q0 .746-.531 1.277a1.74 1.74 0 0 1-1.277.531h-3.884a.3.3 0 0 0-.222.086.3.3 0 0 0-.086.222v3.192h6v1.5z"
  })));
};
export default SvgHeadingMedium;